import { Link, useNavigate, useLocation } from 'react-router-dom';

import ApplicationFooter from '@frolight/components/ApplicationFooter';
import SignInForm from '@frolight/components/SignInForm';
import usePageTitle from '@frolight/hooks/usePageTitle';
import LocaleSelector from '@frolight/components/LocaleSelector';
import useLocalizedFormattedText from '@frolight/hooks/useLocalizedFormattedText';

const SignIn = () => {
  const { lftext } = useLocalizedFormattedText();

  const navigate = useNavigate();
  const location = useLocation();

  const { from } = location.state || { from: { pathname: '/' } };

  usePageTitle(lftext('pages.sign_in.page_title'));

  const onSignInSuccess = () => {
    navigate(from);
  }

  return (
    <div className="sign_in">
      <div className="sign_in__inner">
        <section className="panel">
          <div className="panel__header">
            <header className="small_application_header">
              <Link className="logo_link  logo_link--large" to="/">
                <img className="logo_link__img" src="images/frolight_logo.svg" alt="Frolight logo" />
              </Link>
            </header>
          </div>
          <div className="panel__content">
            <main>
              <SignInForm onSignInSuccess={ onSignInSuccess } />
            </main>
          </div>
        </section>
        <LocaleSelector theme="light" />
      </div>
      <div className="sign_in__footer">
        <ApplicationFooter compact={ true } theme="dark" />
      </div>
    </div>
  );
}

export default SignIn;
